import PasskeyLoginButton from "components/Auth/PasskeyLoginButton/PasskeyLoginButton";
import EnterPIN from "components/Auth/EnterPIN/EnterPIN";
import R2Icon from 'components/R2Icon/R2Icon';
import { useAuth } from "providers/AuthProvider";
import './Login.scss';

const Login = () => {
  const { isLoggedIn } = useAuth();

  if (isLoggedIn) return null;

  return (
    <div className="login">
      <div className="login__content-container">
        <div className="login__logo"><R2Icon /></div>
        <h1>Welcome</h1>
        <PasskeyLoginButton />
        <div className="login__divider"><span>or PIN</span></div>
        <EnterPIN />
      </div>
    </div>
  );
};

export default Login;